import { Injectable, signal, inject } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { RouterStateSnapshot, TitleStrategy } from '@angular/router';

const APP_NAME = 'TALOS';

@Injectable({ providedIn: 'root' })
export class AppTitleStrategy extends TitleStrategy {
  private readonly titleService = inject(Title);

  /** Set a badge count to prefix the title, e.g. (3) Messages | App */
  readonly badgeCount = signal(0);

  override updateTitle(snapshot: RouterStateSnapshot): void {
    const routeTitle = this.buildTitle(snapshot);
    const badge = this.badgeCount();
    const prefix = badge > 0 ? `(${badge}) ` : '';
    const full = routeTitle ? `${prefix}${routeTitle} | ${APP_NAME}` : APP_NAME;
    this.titleService.setTitle(full);
  }

  /** Imperatively set a page title outside of route navigation */
  setPageTitle(title: string): void {
    const badge = this.badgeCount();
    const prefix = badge > 0 ? `(${badge}) ` : '';
    this.titleService.setTitle(`${prefix}${title} | ${APP_NAME}`);
  }
}
